import Vue from 'vue';
import Router from 'vue-router';
// import HelloWorld from '@/components/HelloWorld';
// import Dashboard from '@/components/Dashboard';
import Login from '@/components/pages/Login';
// import Products from '@/components/pages/Products';
// import Coupons from '@/components/pages/Coupons';
// import Orders from '@/components/pages/Orders';
import CustomerOrder from '@/components/pages/CustomerOrders';
import CustomerCheckout from '@/components/pages/CustomerCheckout';
// import ProductInfos from '@/components/pages/ProductInfos';
// import Cat1 from '@/components/pages/Cat1'
import Main from '@/components/Main'
import LineLogin from '../components/pages/LineLogin.vue'
import OrderSuccess from '../components/pages/OrderSuccess.vue'
import CustomerInfo from '../components/pages/CustomerInfo.vue'

Vue.use(Router);


export default new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '*',
      redirect: '/login',
    },

    // {
    //   path: '/',
    //     redirect: '/login'
    // },

    {
      path: '/login',
      name: 'Login',
      component: Login,
    },

    {
      path: '/linelogin',
      name:　'LineLogin',
      component: LineLogin,
    },

    {
      path: '/customer',
      name: 'Main',
      component: Main,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'customer_order',
          name: 'CustomerOrder',
          component: CustomerOrder,
          meta: { requiresAuth: true },
        },
        {
          path: 'customer_checkout',
          name: 'CustomerCheckout',
          component: CustomerCheckout,
          meta: { requiresAuth: true }
        },
        {
          path: 'success',
          name: 'OrderSuccess',
          component: OrderSuccess,
          meta: { requiresAuth: true }
        },
        {
          path: 'customer_profile',
          name: 'CustomerInfo',
          component: CustomerInfo,
          meta: { requiresAuth: true }
        },
      ],
    },

    // {
    //   path: '/admin',
    //   name: 'Dashboard',
    //   component: Dashboard,
    //   meta: { requiresAuth: true },
    //   children: [
    //     {
    //         path: 'cat1',
    //         name: 'Cat1',
    //         component: Cat1,
    //         meta: { requiresAuth: true },
    //     },
    //     {
    //         path: 'productInfos',
    //         name: 'ProductInfos',
    //         component: ProductInfos,
    //         meta: { requiresAuth: true },
    //     },
    //     {
    //       path: 'products',
    //       name: 'Products',
    //       component: Products,
    //       meta: { requiresAuth: true },
    //     },
    //     {
    //       path: 'orders',
    //       name: 'Orders',
    //       component: Orders,
    //       meta: { requiresAuth: true },
    //     },
    //   ],
    // },



  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js